import React from 'react';
import { Container, Panel } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import { PageTitle } from 'components/PageTitle/PageTitle';

export function MyAdminModule() {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle title={t('My Admin Area')} />
      <Container>
        <Panel spacing={0}>
          <div>{t('My Admin Area content coming soon')}</div>
        </Panel>
      </Container>
    </>
  );
}
